import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import './i18n/config'
import './index.css'
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Manter dados frescos após deploys sem exigir refresh manual
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      staleTime: 0, // SEM CACHE - sempre considerar dados como stale
      gcTime: 0, // SEM CACHE - não manter dados em cache (gcTime substitui cacheTime)
      retry: 1,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)

